import { render, staticRenderFns } from "./CombinedDonutCallsReport.vue?vue&type=template&id=08d582a0&scoped=true"
import script from "./CombinedDonutCallsReport.vue?vue&type=script&lang=js"
export * from "./CombinedDonutCallsReport.vue?vue&type=script&lang=js"
import style0 from "./CombinedDonutCallsReport.vue?vue&type=style&index=0&id=08d582a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d582a0",
  null
  
)

export default component.exports